<template>
    <div ref="sceneContainer" class="scene-container">
    </div>
  </template>
  
  <script>
  import * as THREE from "three";
  import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';
  
  export default {
    mounted() {
      this.initScene();
      this.renderer.domElement.addEventListener("dblclick", this.onDoubleClick);
      window.addEventListener("wheel", this.onScroll, { passive: false });
    },
    data: function () {
      return {
        scene:null,
        renderer:null,
        player: null,
        yaw: 0,
        pitch: 0,
        isFirstPerson:true,
        isMousePressed: false,
        lastMouseX: 0,
        lastMouseY: 0,
        camera:null,
        direction: new THREE.Vector3(),
        raycaster: new THREE.Raycaster(),
        mouse: new THREE.Vector2()
      };
    },
    methods: {
      onScroll(event) {
        //  if (!this.isOverScene) return;

            event.preventDefault(); // Voorkomt pagina-scroll

            const zoomSpeed = 0.5;


            // Zet muiscoördinaten om naar -1 tot 1 range (nodig voor Three.js)
            this.mouse.x = (this.lastMouseX / window.innerWidth) * 2 - 1;
            this.mouse.y = -(this.lastMouseY / window.innerHeight) * 2 + 1;

            // Raycaster schiet vanaf de camera in de richting van de muis
            this.raycaster.setFromCamera(this.mouse, this.camera);

            // Bepaal het punt waar we naartoe zoomen (ver weg als geen object wordt geraakt)
            const targetPoint = new THREE.Vector3();
            this.raycaster.ray.at(10, targetPoint); // 10 is een arbitrale afstand

            // Bereken richting van de camera naar targetPoint
            this.direction.subVectors(targetPoint, this.player.position).normalize();

            // Verplaats de player richting target
            const zoomFactor = -event.deltaY * 0.01 * zoomSpeed;
            this.player.position.addScaledVector(this.direction, zoomFactor);
      },
      initScene() {
        this.scene = new THREE.Scene();
       // this.scene.background = new THREE.Color("#ADD8E6"); // Lichtblauwe achtergrond
        let url = "https://raw.githubusercontent.com/gkjohnson/3d-demo-data/master/hdri/aristea_wreck_puresky_2k.hdr";
        this.loadEnvMap(url);
  
        this.camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
      //  this.camera.position.set(0, 2, 10);

        this.player = new THREE.Object3D();
        this.player.add(this.camera);
        this.player.position.set(0, 2, 0);
        this.scene.add(this.player);
  
        this.renderer = new THREE.WebGLRenderer({ antialias: true });
        this.renderer.setSize(window.innerWidth, window.innerHeight);
        this.$refs.sceneContainer.appendChild(this.renderer.domElement);
  
        this.addFloor();
  
        this.addCubeGrid(40, 2);
  
        window.addEventListener("resize", this.onWindowResize);
          
        this.animate();
  
        window.addEventListener("mousemove", this.onMouseMove);
        window.addEventListener("mousedown", this.onMouseDown);
        window.addEventListener("mouseup", this.onMouseUp);
      },
      addFloor(){
        var floorPlane = new THREE.Mesh(
        new THREE.PlaneGeometry(),
        new THREE.MeshStandardMaterial( {
            color: 0x00ee00,
            roughness: 0,
            metalness: 1
        } )
        );
        floorPlane.name = "floor";
        floorPlane.scale.setScalar( 500 );
        floorPlane.rotation.x = - Math.PI / 2;
        floorPlane.receiveShadow = true; 
        this.scene.add( floorPlane );
      },
      onDoubleClick(){
        this.isFirstPerson = true;  
      },
      onMouseDown(event) {
        this.isMousePressed = true;
        this.lastMouseX = event.clientX;
        this.lastMouseY = event.clientY;
      }, 
      onMouseUp(event) {
        this.isMousePressed = false;
      },
      onMouseMove(event) {
        if (this.isFirstPerson && this.isMousePressed) {

          this.yaw += (event.clientX - this.lastMouseX) * 0.002; // Horizontale rotatie (links/rechts)
          this.pitch += (event.clientY - this.lastMouseY) * 0.002; // Verticale rotatie (omhoog/omlaag)
  
          // Beperk de verticale rotatie
          this.pitch = Math.max(-Math.PI / 2, Math.min(Math.PI / 2, this.pitch));
  
          this.camera.rotation.set(this.pitch, 0, 0);
          this.player.rotation.set(0, this.yaw, 0);
        }
  
        this.lastMouseX = event.clientX;
        this.lastMouseY = event.clientY;
      }, 
      async loadEnvMap(url) {
      try {

        const texture = await new Promise((resolve, reject) => {
          new RGBELoader()
            .load(
              url,
              (texture) => {
                // if (this.scene.environment) {
                //   this.scene.environment.dispose();
                // }

                texture.mapping = THREE.EquirectangularReflectionMapping;
                this.scene.environment = texture;
                this.scene.background = this.scene.environment ;
                this.scene.backgroundIntensity = 0.6;
                resolve(texture); // Resolves the promise when the texture is successfully loaded
              },
              undefined, // Optionally, you can handle progress updates here
              (error) => {
                reject(error); // Rejects the promise if an error occurs
              }
            );
        });
      } catch (error) {
        console.error('Error loading texture:', error); // Foutmelding wordt hier afgevangen
      }
      },
      addCubeGrid(gridSize, spacing) {
        const geometry = new THREE.BoxGeometry(1, 1, 1);
        const material = new THREE.MeshStandardMaterial({ 
            color: 0xffffff,
            metalness:0.5,
            roughness:0
        });
  
        for (let i = 0; i < gridSize; i++) {
          for (let j = 0; j < gridSize; j++) {
            const cube = new THREE.Mesh(geometry, material);
            cube.castShadow = true;
            cube.receiveShadow = true;
            cube.position.set(i * spacing - (gridSize * spacing) / 2, 0.5, j * spacing - (gridSize * spacing) / 2);
            this.scene.add(cube);
          }
        }
      },
      onWindowResize() {
        this.camera.aspect = window.innerWidth / window.innerHeight;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(window.innerWidth, window.innerHeight);
      },
      animate() {
        requestAnimationFrame(this.animate);
        this.renderer.render(this.scene, this.camera);
      }
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.onWindowResize);
    },
  };
  </script>
  
  <style>
  .scene-container {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
  }
  </style>
  